import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class FaceUpInstruction extends Instruction<"face-up"> {
  readonly type = "face-up";

  act(context: ProgramModel) {
    context.cursorDirection = "up";
  }
}
